const selectors = {
    carouselQuote: '.evp_carousel-quote__swiper',
    carousel: '.evp_carousel__swiper',
    carouselPagination: '.swiper-pagination',
    carouselNext: '.evp_swiper__arrow--next',
    carouselPrev: '.evp_swiper__arrow--prev',
    langSelect: '.evp_lang-select__slim-select',
}

export default selectors;